import React, {useEffect, useState} from 'react';
import './SwitchModel.scss';
import Text from "../../../../modules/Text/Text";
import {ArrowLeftIcon, SortIcon} from "../../../../image";
import {Popover} from "antd";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {UpdateChatSessionService} from "../../../../redux/actions/chatActions";

const MODELS = (t) => {
    return [
        {
            id: 0,
            value: 'fast',
            label: t('model_label_1'),
            description: 'GPT 4.1-mini',
        },
        {
            id: 1,
            value: 'smart',
            label: t('model_label_2'),
            description: 'GPT 4.1',
        },
        {
            id: 2,
            value: 'test',
            label: t('model_label_3'),
            description: 'GPT 4.1-mini',
        }
    ]
};

const SwitchModel = ({data,updateChat}) => {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(data?.session?.llm_type);
    const findModel = MODELS(t).find((model) => model.value === selectedValue);
    const selectedIdSession = useSelector(state => state.chat.selectedIdSession);

    function handleOpenChange(newOpen) {
        setOpen(newOpen);
    }

    const changeModel = async (value) => {
        try{
           setSelectedValue(value);
           handleOpenChange(false);
           await UpdateChatSessionService(selectedIdSession, {llm_type: value});
           await updateChat();
        }catch (e) {
            console.error(e)
        }
    };

    useEffect(()=>{
       setSelectedValue(data?.session?.llm_type)
    },[data]);

    return (
        <Popover
            arrow={false}
            open={open}
            trigger='click'
            placement="bottomLeft"
            overlayClassName='switch-model'
            onOpenChange={handleOpenChange}
            content={
                <div className="switch-model__container">
                    <div className="switch-model__list">
                        {MODELS(t).map((model) => (
                            <div
                                key={model.id}
                                className={`switch-model__list--item ${model.value === selectedValue ? 'active' : ''}`}
                                onClick={() => changeModel(model.value)}
                            >
                                <Text size="f14" color={model.value === selectedValue ? "#1ABB78" : "black"}>{model.label}</Text>
                                <Text size="f14" color="#9898A6">{model.description}</Text>
                            </div>
                        ))}
                    </div>
                </div>
            }
        >
            <div className={`switch-model__label`}>
                <div className={`switch-model__label_wrap`}>
                    <span className="switch-model__label--text">{findModel?.label}</span>
                    <ArrowLeftIcon className={`switch-model__label--arrow ${open ? 'open' : ''}`}/>
                </div>
            </div>
        </Popover>
    );
};

export default SwitchModel;